import { useTranslation } from "react-i18next";
import Field from "../../../../../components/Field";
import Switch from "../../../../../components/Inputs/Switch";

function Settings({ form, columns }) {
    const { t } = useTranslation();


    return (
        <div className="w-100 row">
            <div className="col-6">

                <Field name="replaceJobWhenItIsChanged" valuePropName="checked">
                    <Switch>{t("replace-job-when-it-is-changed")}</Switch>
                </Field>

            </div>
        </div>
    );
}

export default Settings;
